/**
 * webmap-polygons.js — простая подсветка выбранного участка через MVT
 */
(function() {
  'use strict';

  if (typeof window._polygonsVisible === 'undefined') {
    window._polygonsVisible = true;
  }

  const API_BASE = window.location.origin;
  const POLYGONS_LAYER_ID = 'lots-polygons';
  const POLYGONS_MVT_URL = API_BASE + '/tiles/polygons_mvt/{z}/{x}/{y}';

  const _dom = {};
  function cacheDom() {
    const ids = [
      'ad_type_ips', 'filter-actual-only', 'filter-data-mode',
      'filter-history-from-month', 'filter-history-from-year',
      'filter-history-to-month', 'filter-history-to-year'
    ];
    ids.forEach(function(id) { _dom[id] = document.getElementById(id); });
  }

  function isAuthForFilters() {
    return typeof window.goszemlyaAuth === 'object' &&
           typeof window.goszemlyaAuth.isAuthenticated === 'function' &&
           window.goszemlyaAuth.isAuthenticated();
  }

  function getHistoryValue(dir) {
    const mEl = _dom['filter-history-' + dir + '-month'];
    const yEl = _dom['filter-history-' + dir + '-year'];
    if (!mEl || !yEl) return null;
    const m = mEl.value;
    const y = yEl.value;
    if (!m || !y) return null;
    return y + '-' + m;
  }

  function isHistoricalMode() {
    const actualOnlyEl = _dom['filter-actual-only'];
    return actualOnlyEl ? !actualOnlyEl.checked : false;
  }

  function setPolygonsVisibility(map, visible) {
    ['lots-polygons-fill', 'lots-polygons-line'].forEach(function(id) {
      if (map.getLayer(id)) {
        try {
          map.setLayoutProperty(id, 'visibility', visible ? 'visible' : 'none');
        } catch (e) {
          console.warn('[Polygons] setLayoutProperty failed:', e);
        }
      }
    });
  }

  function buildPolygonsMvtUrl() {
    const qp = new URLSearchParams();
    const actualOnlyEl = _dom['filter-actual-only'];
    const actualOnly = actualOnlyEl ? actualOnlyEl.checked : true;
    qp.set('actual_only', actualOnly ? 'true' : 'false');
    if (!actualOnly) {
      const from = getHistoryValue('from');
      const to = getHistoryValue('to');
      if (from) qp.set('history_from', from);
      if (to) qp.set('history_to', to);
      // In historical mode, polygon drops are rendered only for lots that are
      // currently active AND whose deadline falls inside the selected period.
      qp.set('active_in_history', 'true');
    }
    // Include IPS lots in the tile only when the IPS filter is enabled.
    const ipsEl = document.getElementById('ad_type_ips');
    if (ipsEl && ipsEl.checked) {
      qp.set('include_ips', 'true');
    }
    const q = qp.toString();
    return POLYGONS_MVT_URL + (q ? '?' + q : '');
  }

  function getLotFilterExpression() {
    if (typeof window.buildLotFilterExpression === 'function') {
      return window.buildLotFilterExpression();
    }
    return null;
  }

  function selectedExpr(sel) {
    return ['==', ['to-string', ['get', 'lot_id']], sel || ''];
  }

  function addPolygonLayers(map) {
    if (map.getSource(POLYGONS_LAYER_ID)) return;

    map.addSource(POLYGONS_LAYER_ID, {
      type: 'vector',
      tiles: [buildPolygonsMvtUrl()],
      minzoom: 6,
      // Backend generates polygon tiles up to z13; beyond that MapLibre should
      // overzoom the z13 tile instead of requesting empty higher-zoom tiles.
      maxzoom: 13,
      attribution: '',
      generateId: true
    });

    const sel = window._selectedLotId || '';
    const expr = selectedExpr(sel);

    map.addLayer({
      id: 'lots-polygons-fill',
      type: 'fill',
      source: POLYGONS_LAYER_ID,
      'source-layer': 'lots_polygons',
      minzoom: 6,
      paint: {
        'fill-color': ['case', expr, 'rgba(211, 47, 47, 0.45)', 'rgba(37, 99, 235, 0.18)'],
        'fill-outline-color': ['case', expr, '#d32f2f', 'rgba(37, 99, 235, 0.55)']
      }
    });
    const filter = getLotFilterExpression();
    if (filter) {
      try {
        map.setFilter('lots-polygons-fill', filter);
      } catch (e) {
        console.warn('[Polygons] initial setFilter failed:', e);
      }
    }

    map.addLayer({
      id: 'lots-polygons-line',
      type: 'line',
      source: POLYGONS_LAYER_ID,
      'source-layer': 'lots_polygons_outline',
      minzoom: 6,
      paint: {
        'line-color': ['case', expr, '#d32f2f', 'rgba(37, 99, 235, 0.85)'],
        'line-width': ['case', expr, 3, 2]
      }
    });
    if (filter) {
      try {
        map.setFilter('lots-polygons-line', filter);
      } catch (e) {
        console.warn('[Polygons] initial setFilter failed:', e);
      }
    }

    map.on('click', 'lots-polygons-fill', function(e) {
      if (window._mapToolsMeasureMode) return;
      if (!e.features || !e.features.length) return;
      const lotId = e.features[0].properties.lot_id;
      if (lotId) {
        window.dispatchEvent(new CustomEvent('lot:select', {
          detail: { lotId: String(lotId), source: 'polygon', zoomToFit: true }
        }));
      }
    });
    map.on('mouseenter', 'lots-polygons-fill', function() {
      map.getCanvas().style.cursor = 'pointer';
    });
    map.on('mouseleave', 'lots-polygons-fill', function() {
      map.getCanvas().style.cursor = '';
    });
  }

  function updateSelection(selectedLotId) {
    const map = window.map;
    if (!map) return;
    const expr = selectedExpr(selectedLotId);
    try {
      if (map.getLayer('lots-polygons-fill')) {
        map.setPaintProperty('lots-polygons-fill', 'fill-color', ['case', expr, 'rgba(211, 47, 47, 0.45)', 'rgba(37, 99, 235, 0.18)']);
        map.setPaintProperty('lots-polygons-fill', 'fill-outline-color', ['case', expr, '#d32f2f', 'rgba(37, 99, 235, 0.55)']);
      }
      if (map.getLayer('lots-polygons-line')) {
        map.setPaintProperty('lots-polygons-line', 'line-color', ['case', expr, '#d32f2f', 'rgba(37, 99, 235, 0.85)']);
        map.setPaintProperty('lots-polygons-line', 'line-width', ['case', expr, 3, 2]);
      }
    } catch (e) {
      console.warn('[Polygons] updateSelection failed:', e);
    }
  }

  function removePolygonLayers(map) {
    ['lots-polygons-fill', 'lots-polygons-line'].forEach(function(id) {
      if (map.getLayer(id)) map.removeLayer(id);
    });
    if (map.getSource(POLYGONS_LAYER_ID)) map.removeSource(POLYGONS_LAYER_ID);
  }

  function applyPolygonFilter() {
    const map = window.map;
    if (!map) return;

    const newUrl = buildPolygonsMvtUrl();
    const source = map.getSource(POLYGONS_LAYER_ID);
    if (source && typeof source.setTiles === 'function') {
      const current = (source.tiles && source.tiles[0]) || '';
      if (current !== newUrl) {
        source.setTiles([newUrl]);
      }
    }
    const filter = getLotFilterExpression();
    try {
      if (map.getLayer('lots-polygons-fill')) map.setFilter('lots-polygons-fill', filter || null);
      if (map.getLayer('lots-polygons-line')) map.setFilter('lots-polygons-line', filter || null);
    } catch (e) {
      console.warn('[Polygons] setFilter failed:', e);
    }
  }

  function initPolygonLayers(map) {
    // Idempotent: do not remove existing layers. This keeps polygons
    // persistent across raster base-layer switches.
    if (!map.getSource(POLYGONS_LAYER_ID)) {
      addPolygonLayers(map);
    }
    // Apply current filters immediately so restored or initial state is honored.
    // Historical mode hides polygon drops by default for performance.
    applyPolygonFilter();
  }

  window.addEventListener('map:ready', function(e) {
    cacheDom();
    initPolygonLayers(e.detail.map);
  });

  window.addEventListener('map:styleload', function(e) {
    cacheDom();
    initPolygonLayers(e.detail.map);
  });

  window.addEventListener('filter:change', function() {
    applyPolygonFilter();
  });

  window.addEventListener('auth:change', function() {
    applyPolygonFilter();
  });

  window.addEventListener('polygons:toggle', function(e) {
    const visible = e.detail && e.detail.visible;
    window.toggleLotPolygons(!!visible);
  });

  window.addEventListener('lot:select', function(e) {
    const lotId = e.detail && e.detail.lotId;
    if (!lotId) return;
    updateSelection(String(lotId));
  });

  window.addEventListener('lot:close', function() {
    updateSelection('');
  });

  window.toggleLotPolygons = function(visible) {
    window._polygonsVisible = visible;
    const map = window.map;
    if (!map) return;
    if (visible && !map.getSource(POLYGONS_LAYER_ID)) {
      try { addPolygonLayers(map); } catch (err) { console.error('[Polygons] addPolygonLayers failed:', err); }
    } else if (visible) {
      applyPolygonFilter();
    }
    ['lots-polygons-fill', 'lots-polygons-line'].forEach(function(id) {
      if (map.getLayer(id)) {
        map.setLayoutProperty(id, 'visibility', visible ? 'visible' : 'none');
      }
    });
  };
})();
